<template>
  <div class="info-section">
    <h5>Cycle Triggers</h5>
    <div class="info-grid">
      <div v-if="startTrigger" class="info-item">
        <span class="label">Start Trigger:</span>
        <span class="value">{{ startTrigger.logic }} ({{ startTrigger.delta }} {{ getDeltaUnit(startTrigger.logic) }})</span>
      </div>
      <div v-if="endTrigger" class="info-item">
        <span class="label">End Trigger:</span>
        <span class="value">{{ endTrigger.logic }} ({{ endTrigger.delta }} {{ getDeltaUnit(endTrigger.logic) }})</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CycleTriggersSection',
  props: {
    startTrigger: {
      type: Object,
      default: null
    },
    endTrigger: {
      type: Object,
      default: null
    }
  },
  methods: {
    getDeltaUnit(logic) {
      // Determine if the delta is pressure-related or temperature-related based on the logic
      if (!logic) return '°F'; // Default to temperature

      const logicStr = logic.toString().toLowerCase();

      // Check for pressure-related keywords
      if (logicStr.includes('pressure') ||
          logicStr.includes('press') ||
          logicStr.includes('pa') ||
          logicStr.includes('filter') ||
          logicStr.includes('flow')) {
        return 'Pa';
      }

      // Check for temperature-related keywords
      if (logicStr.includes('temp') ||
          logicStr.includes('temperature') ||
          logicStr.includes('delta') ||
          logicStr.includes('cooling') ||
          logicStr.includes('heating')) {
        return '°F';
      }

      // Default to temperature unit
      return '°F';
    }
  }
};
</script>

<style lang="scss" scoped>
.info-section {
  margin-bottom: 24px;
  background: rgb(24, 32, 64);
  border-radius: 8px;
  padding: 20px;
  border: 1px solid rgb(58, 74, 107);

  h5 {
    margin: 0 0 16px 0;
    color: #ffffff;
    font-size: 16px;
    font-weight: 600;
    border-bottom: 2px solid #4a9eff;
    padding-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 8px;

    &::before {
      content: '⚡';
      font-size: 14px;
    }
  }

  .info-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
    gap: 16px;

    .info-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 20px;
      background: rgb(32, 40, 80);
      border-radius: 8px;
      border: 1px solid rgb(58, 74, 107);
      min-height: 52px;
      word-break: break-word;
      transition: all 0.2s ease;

      &:hover {
        background: rgb(42, 58, 107);
        border-color: #4a9eff;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
      }

      .label {
        font-weight: 600;
        color: #ffffff;
        font-size: 13px;
        flex-shrink: 0;
        margin-right: 16px;
        min-width: 140px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }

      .value {
        font-weight: 700;
        color: #ffffff;
        font-size: 14px;
        text-align: right;
        word-break: break-word;
        overflow-wrap: break-word;
        font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
      }
    }
  }
}
</style>
